export default __webpack_public_path__ + "static/media/glance-text.eb65d079.svg";